import { useEffect } from 'react';
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import { formatPercentage, formatCurrency } from '@roc/ui/utils';
import { observer } from 'mobx-react';
import { Tooltip } from '@roc/ui'
import WarningIcon from '@material-ui/icons/Warning';
import { Theme, createStyles, lighten, makeStyles, useTheme } from '@material-ui/core/styles';
import {
  Button,
} from '@roc/ui';


const tableClasses = makeStyles((theme: Theme) =>
  createStyles({
    paper: {
      padding: theme.spacing(4),
    },
    root: {
      width: '100%',
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
    },
    tableRowFont: {
      fontSize: theme.typography.pxToRem(20),
    },
    header: {
      fontWeight: 500,
      fontSize: 16,
      letterSpacing: '1.25px',
      backgroundColor: 'transparent',
      borderBottom: 'solid 1px',
      padding: '16px',
      textTransform: 'uppercase',
      '& div': {
        textAlign: 'center'
      }
    },
    customizeButton: {
      borderRadius: '6px',
      fontSize: '14px',
      marginRight: '-15px',
      border: `1px solid ${theme.palette.primary.main}`,
      color: theme.palette.primary.main,
      backgroundColor: 'white',
      width: '175px',
      letterSpacing: '1.25px',
      paddingTop: '8px',
      paddingBottom: '8px',
      paddingLeft: '32px',
      paddingRight: '32px',
      height: '40px',
      textTransform: 'uppercase'
    },
    anyOtherRowClass: {
      backgroundColor: lighten(theme.palette.primary.main, 0.9),
    },
    bold: {
      fontWeight: 'bold'
    }
  }),
);

export const LoanRatesTable = observer(({ store, loanEconomicsStore }: { store: any, loanEconomicsStore: any }) => {
  const theme = useTheme();
  const { rateScenarios, rateScenarioValidationErrors, existValidationError } = loanEconomicsStore;
  const tableClass = tableClasses();
  useEffect(() => {
    loanEconomicsStore.clearSelectedQuotes();
    loanEconomicsStore.fetchRatesAndLoanTermsV2();
    loanEconomicsStore.fetchRatesForCustomQuotes();
  }, []);
  return (<Box mt={2} display={'flex'}>
    <TableContainer>
      <Table size='small'>
        <TableHead>
          <TableRow>
            <TableCell align="left" className={tableClass.header}>Rate</TableCell>
            <TableCell align="left" className={`${tableClass.header}`}>
              <Box>
                Origination
              </Box>
              <Box>
                points and fees
              </Box>
            </TableCell>
            <TableCell align="center" className={tableClass.header}>
              <Box>
                Monthly payment
              </Box>
              <Box>
                (PI payment)
              </Box>
            </TableCell>
            <TableCell align="left" className={tableClass.header}>
              <Box display={'flex'} alignItems={'center'}>
              </Box>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {
            existValidationError && rateScenarios?.map((scenario, i) => {
              return (<TableRow key={i} className={i % 2 !== 0 ? tableClass.anyOtherRowClass : ''}>
                <TableCell className={tableClass.tableRowFont} component="th" scope="row" align="left">
                  NA
                </TableCell>
                <TableCell className={tableClass.tableRowFont} component="th" scope="row" align="center">
                  NA
                </TableCell>
                <TableCell className={tableClass.tableRowFont} component="th" scope="row" align="center">
                  NA
                </TableCell>
                <TableCell className={tableClass.tableRowFont} component="th" scope="row" align="center">
                  <Tooltip title={rateScenarioValidationErrors ?? '"Please note our minimum loan amount is CRC75,000.00. Please reach out to your account executive/relationship manager to discuss this loan."'} placement="top" arrow>
                    <WarningIcon fontSize="medium" style={{
                      color: 'orange',
                      marginBottom: '-5px'
                    }} />
                  </Tooltip>
                </TableCell>
              </TableRow>)
            })
          }
          {
            !existValidationError && rateScenarios?.map((scenario, i) => {
              if (!scenario.rate || !scenario?.pricerLoanTerms?.monthlyPayment) {
                return;
              }
              return (
                <TableRow key={scenario.rate} className={i % 2 !== 0 ? tableClass.anyOtherRowClass : ''}>
                  <TableCell className={`${tableClass.bold} ${tableClass.tableRowFont}`} component="th" scope="row" align="left">
                    {formatPercentage(scenario.rate)}
                  </TableCell>
                  <TableCell className={tableClass.tableRowFont} component="th" scope="row" align="center">
                    {formatCurrency(((scenario.pointsAndFeesPercent + (loanEconomicsStore?.borrowerSubmissionFees?.termOriginationPoints ?? 0)) * scenario.pricerLoanTerms.amount) / 100 + loanEconomicsStore?.borrowerSubmissionFees?.totalAddOnFee)}
                  </TableCell>
                  <TableCell className={tableClass.tableRowFont} component="th" scope="row" align="center">
                    {formatCurrency(scenario.pricerLoanTerms?.monthlyPaymentWithoutExpenses)}
                  </TableCell>
                  <TableCell align={'right'}>
                    <Box my={1}>
                      <Button
                        size='small'
                        variant="contained"
                        className={tableClass.customizeButton}
                        onClick={() => loanEconomicsStore.setSelectedQuotes(scenario)}
                        testId="createCustomQuote"
                      >
                        Customize
                      </Button>
                    </Box>
                  </TableCell>
                </TableRow>
              )
            })
          }
        </TableBody>
      </Table>
    </TableContainer>
  </Box>)
})